<div class="container">
  <div class="row">
    <div class="col-sm-6 col-md-5 rp-xs" style="margin : auto;" >

      <form *ngIf = 'verifyIsDone && tokenIsValid' (ngSubmit)="onSubmit()" #changePasswordForm="ngForm">
        <div style="padding : 10px;text-align: center;" >
          <span style="color : red;">{{ errorMsg }}</span>
        </div>
        <br/>
        <div class="form-group row has-danger" *ngIf="errorMsg">
          <div class="col-12">
            <div class="form-control-feedback"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ errorMsg }}</div>
          </div>
        </div>
        <!-- old password field -->
        <!--
          <div class="form-group row" [ngClass]="{'has-danger':  (old_password.errors?.old_password && old_password.touched) || errorMsg }">
            <div class="col-12">
              <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                <div class="input-group-addon"><i class="fa fa-lock" aria-hidden="true"></i></div>
                <input class="form-control" type="password" value="" name="old_password" placeholder="Mot de passe actuel" [(ngModel)]="user.old_password" #old_password="ngModel" required email>
              </div>
              <div class="form-control-feedback" *ngIf="old_password.touched && old_password.dirty && user.old_password.length<=0"><i class="fa fa-info-circle" aria-hidden="true"></i> Votre adresse e-mail est requise</div>
              <div class="form-control-feedback" *ngIf="old_password.touched && !old_password.valid && user.old_password.length>0 "><i class="fa fa-info-circle" aria-hidden="true"></i> Votre adresse e-mail est invalide</div>
            </div>
          </div>
        -->
        <!-- new password field -->
        <div class="form-group row" [ngClass]="{'has-danger':  (password.errors?.password && password.touched) || errorMsg }">
          <div class="col-12">
            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
              <div class="input-group-addon"><i class="fa fa-lock" aria-hidden="true"></i></div>
              <input class="form-control" type="password" value="" name="password" placeholder="Nouveau mot de passe" [(ngModel)]="user.password" #password="ngModel" required >
            </div>
            <div class="form-control-feedback" *ngIf="password.touched && user.password.length == 0"><i class="fa fa-info-circle" aria-hidden="true"></i> Votre mot de passe est requise</div>
            <div class="form-control-feedback" *ngIf="password.touched && user.password.length < 8"><i class="fa fa-info-circle" aria-hidden="true"></i> Votre mot de passe doit contenir au moins 8 caractères</div>
          </div>
        </div>
        <!-- re new password field -->
        <div class="form-group row" [ngClass]="{'has-danger':  (rpassword.errors?.rpassword && rpassword.touched) || errorMsg }">
          <div class="col-12">
            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
              <div class="input-group-addon"><i class="fa fa-lock" aria-hidden="true"></i></div>
              <input class="form-control" type="password" value="" name="rpassword" placeholder="Comfirmez le mot de passe" [(ngModel)]="user.rpassword" #rpassword="ngModel" required >
            </div>
            <div class="form-control-feedback" *ngIf="rpassword.touched && user.rpassword.length == 0"><i class="fa fa-info-circle" aria-hidden="true"></i> Veuillez confirmez votre mot de passe</div>
            <div class="form-control-feedback" *ngIf="rpassword.touched && user.rpassword.length < 8 "><i class="fa fa-info-circle" aria-hidden="true"></i>Votre mot de passe doit contenir au moins 8 caractères</div>
            <div class="form-control-feedback" *ngIf="rpassword.touched &&  user.rpassword != user.password "><i class="fa fa-info-circle" aria-hidden="true"></i> Vos mot de passe ne sont pas équivalent</div>
          </div>
        </div>
        <!-- password field -->
        <div class="form-group row ">
          <div class="offset-sm-1 col-sm-10">
            <div style="text-align: center;" *ngIf="onloading" >
              <i class="fa fa-spinner" aria-hidden="true" ></i>
            </div>
            <button *ngIf="!onloading" type="submit" class="btn btn-primary btn-lg btn-block" [disabled]="!(user.password.length >= 8 && user.rpassword == user.password)">Changer</button>
          </div>
        </div>
      </form>
      <section *ngIf = 'verifyIsDone && !tokenIsValid' >
        <div style="padding : 10px;" >
          <div class="alert alert-danger" role="alert">
            <i class="fa fa-info-circle" aria-hidden="true"></i> Votre lien n'est pas valide ou expiré
          </div>
        </div>
      </section>
      <!-- <section *ngIf = 'tokenIsValid == true' >
        <div style="padding : 10px;" >
          <h1 style="text-align: center;">Le token n'est pas valide</h1>
        </div>
      </section>
       -->

    </div>
  </div>
</div>
